var $ = require('jquery');
var ShareButton = require('diy/social/ShareButton');
var websiteData = require('diy/util/websiteData');

var LinkedInShare;


/**
 * @class diy.social.LinkedInShare
 * @template diy.social.LinkedInShare
 * @lends {diy.social.LinkedInShare.prototype}
 * @extends {diy.social.ShareButton}
 * @constructor
 */
LinkedInShare = ShareButton.extend({

    /**
     * @type {{
     *      onClick: Function,
     *      image: String,
     *      url: String,
     * }}
     */
    options: undefined,
    /**
     *
     * @param {*} options
     * @private
     * @returns {diy.social.LinkedInShare}
     */
    setOptions: function (options) {
        var
            defaults = {
                onClick: undefined,
                image: websiteData.getCdnUrl() + 's/diy/social/img/linkedin/linkedin_' + this.market + '.png',
                url: websiteData.getWebUrl()
            };

        this.options = $.extend(true, {}, defaults, options);
        return this;
    },
    /**
     *
     * @returns {String}
     */
    convertToLinkedInShareLocale: function () {
        var languageCode = '';
        switch (this.language) {
            case 'de':
                languageCode = 'de_DE';
                break;
            case 'en':
                languageCode = 'en_US';
                break;
            case 'es':
                languageCode = 'es_ES';
                break;
            case 'fr':
                languageCode = 'fr_FR';
                break;
            case 'it':
                languageCode = 'en_IT';
                break;
            case 'pl':
                languageCode = 'pl_PL';
                break;
        }
        return languageCode;
    },

    /**
     * @private
     */
    createButton: function () {
        var $share;

        this.$element.addClass('diy-share-linkedin');
        $share = $('<img src="' + this.options.image + '">').appendTo(this.$element);
        $share.css({cursor: 'pointer'});
        $share.bind('click', this.onClick.bind(this));
    },
    /**
     * @private
     */
    onClick: function () {
        this.executeCallback(this.options.onClick);

        var
            url = 'https://www.linkedin.com/cws/share?url={{link}}',
            params = $.param({
                'original_referer': websiteData.getWebUrl(),
                'token': '',
                'isFramed': false,
                'lang': this.convertToLinkedInShareLocale(),
                '_ts': Date.now()
            });

        url = url.replace('{{link}}', encodeURIComponent(this.options.url));

        this.openWindow(url + '&' + params);
    }
});

module.exports = LinkedInShare;



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/social/LinkedInShare.js
 ** module id = 739
 ** module chunks = 0
 **/